import React from 'react' 
import {getQuarter} from 'date-fns'

import CourseCalendarItem from '../course-calendar-item'

class CourseCalendarQuarterList extends React.Component {
  render(){
    let {courseSchedule} = this.props
    courseSchedule = courseSchedule || []
    let courseScheduleByQuarter = courseSchedule.reduce((result, course) => {
      let quarter = getQuarter(course.startDate)
      result[quarter] = result[quarter] || []
      result[quarter].push(course)
      return result
    }, {})

    let quarters = Object.keys(courseScheduleByQuarter).sort()
    return (
      <div className='course-calendar-quarter-list'>
        {quarters.map((quarter, key) => 
          <div key={key} className='course-calender-quarter'>
            <h2 style={{textAlign: 'center'}}> {this.props.year} Quarter {quarter}</h2>
            {courseScheduleByQuarter[quarter].map((course, i) => 
              <CourseCalendarItem 
                key={i} 
                course={course}
                designateLocation={this.props.designateLocation} 
                />)}
          </div>
        )}
      </div>
    )
  }
}

export default CourseCalendarQuarterList



// WEBPACK FOOTER //
// ./src/components/course-calendar-quarter-list/index.js